import { motion } from "framer-motion"
import styles from "Styles/Background/backgroundContainer.module.css";
import useSegment from 'Hooks/useSegment';
import React from 'react'
import useWindowSize from "Hooks/useWindowSize";


const BackgroundHorseshoe = () => {
	// const { width } = useWindowSize();

  return (
    <motion.svg 
      className={styles.backgroundElement}
      style={{
        bottom: "-100px",
        right: "-20px",
				zIndex: 1,
      }}
      animate={{
        x: -200,
        y: 100,
        rotate: 180,
      }}
      transition={{
        duration: 60,
        repeat: Infinity,
        repeatType: "mirror",
        type: "tween"
      }}
      width="356" height="342" viewBox="0 0 356 342" fill="none" xmlns="http://www.w3.org/2000/svg"
    >
    <g clipPath="url(#clip0_112_226)">
    <path d="M189.574 272.971C268.122 251.738 314.556 170.852 293.299 92.2939L206.64 115.717C214.942 146.403 196.801 177.992 166.121 186.284C135.457 194.572 103.857 176.431 95.5544 145.744L8.88521 169.166C30.147 247.73 111.043 294.201 189.574 272.971Z" fill="#FCCA23"/>
    </g>
    <defs>
    <clipPath id="clip0_112_226">
    <rect width="288.507" height="208.749" fill="white" transform="translate(0 176.006) rotate(-37.5937)"/>
    </clipPath>
    </defs>
    </motion.svg>
  )
}

const BackgroundStar = ()=> {
	// const { width } = useWindowSize();

  return (
    <motion.svg
      style={{
        bottom: 0,
        left: "-50px",
				scale: 2,
				zIndex: 1,
      }}
      animate={{
        x: 0,
        y: 0,
        rotate: -360,
      }}
      transition={{
        duration: 30,
        repeat: Infinity,
        repeatType: "mirror"
      }}
      className={styles.backgroundElement} 
      width="133" height="133" viewBox="0 0 133 133" fill="none" xmlns="http://www.w3.org/2000/svg"
    >

      <g clipPath="url(#clip0_112_208)">
      <path d="M91.8236 90.1076L104.098 90.8L99.1445 79.5391L110.935 75.9839L102.431 67.1127L112.313 59.7355L101.281 54.3284L108.059 44.0196L95.8309 42.7221L98.693 30.7254L86.747 33.7008L85.3423 21.4622L75.1134 28.3486L69.6186 17.3441L62.3423 27.3108L53.4134 18.8693L49.9718 30.7159L38.6882 25.8565L39.4913 38.15L27.2138 37.4556L32.1672 48.7165L20.3763 52.2717L28.8807 61.1429L19.0018 68.522L30.0338 73.9292L23.2563 84.238L35.4808 85.5335L32.622 97.5322L44.568 94.5568L45.9727 106.795L56.1983 99.907L61.6964 110.914L68.9694 100.945L77.8983 109.386L81.3431 97.5417L92.6268 102.401L91.8236 90.1076Z" fill="#1754E7"/>
      </g>
      <defs>
      <clipPath id="clip0_112_208">
      <rect width="96.3363" height="96.3363" fill="white" transform="translate(49.8867) rotate(31.1877)"/>
      </clipPath>
      </defs>
    </motion.svg>
  )
}

const BackgroundRing = () => {
	return (
		<motion.svg 
			className={`${styles.backgroundElement}`}
				style={{
					right: "100px",
					top: "50%",
					zIndex: 1,
				}}
				animate={{
					x: 100,
					y: 50,
					rotate: 180
				}}
				transition={{
					duration: 20,
					repeat: Infinity,
					type: "tween",
					repeatType: "mirror"
				}}
			width="119" height="119" viewBox="0 0 119 119" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path d="M119 59.5C119 92.3609 92.3609 119 59.5 119C26.6391 119 0 92.3609 0 59.5C0 26.6391 26.6391 0 59.5 0C92.3609 0 119 26.6391 119 59.5ZM16.9283 59.5C16.9283 83.0117 35.9883 102.072 59.5 102.072C83.0117 102.072 102.072 83.0117 102.072 59.5C102.072 35.9883 83.0117 16.9283 59.5 16.9283C35.9883 16.9283 16.9283 35.9883 16.9283 59.5Z" fill="#7DECB9"/>
		</motion.svg>

	)
}

const BackgroundCircle = ({isExiting}) => {
	const { width } = useWindowSize();
  return (
    <motion.svg
      className={`${styles.backgroundElement}`}
      style={{
        left: "100px",
        top: width > 768 ? "200px" : 0,
				scale: width > 768 ? 2 : 1.5,
				zIndex: 1,
      }}
      animate={{
        x: 100,
        y: 50,
        rotate: 180
      }}
      transition={{
        duration: 20,
        repeat: Infinity,
        type: "tween",
        repeatType: "mirror"
      }}

      width="158" height="158" viewBox="0 0 158 158" fill="none" xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="79" cy="79" r="79" fill="#7DECB9"/>
    </motion.svg>
  )
}

const CompletePageBackground = () => {


  // const isFullWidth = backgroundStyle === "fullwidth";
  const segment = useSegment();
  const isCompletePage = ()=>{
    return segment === "complete"
  }

  const bgElements = {
    completePage: [
      {
        element: isCompletePage() ? BackgroundHorseshoe: null,
        key: "horseshoe"
      },
			{
				element: isCompletePage() ? BackgroundStar : null,
				key: "star"
			},
			{
				element: isCompletePage() ? BackgroundCircle : null,
				key: "circle"
			},
			{
				element: isCompletePage() ? BackgroundRing : null,
				key: "ring"
			}
    ]
  }

  return (
    <>
			{
				bgElements.completePage.filter(j => j.element).map((el, i)=> (
					React.createElement(el.element, {
						key: el.key,
						// isExiting: transitionState
					})
				))
			}

    </>
  )
}

export default CompletePageBackground;